import { Col, Form, Row, Tooltip } from "antd"

import InputNumber from "../../../../../components/Input/InputNumber.tsx"
import { type ProjectFormData } from "../project-form-data.ts"

export function BudgetSummarySection() {
  const form = Form.useFormInstance()

  const salesPrice = Form.useWatch("sales_price", form)
  const plannedPayable = Form.useWatch("planned_payable", form)

  const margin = (salesPrice ?? 0) - (plannedPayable ?? 0)
  const hasNegativeMargin =
    salesPrice != null && plannedPayable != null && margin < 0

  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label="Sales Price"
            name="sales_price"
          >
            <InputNumber
              prefix="$"
              placeholder="0.00"
              step={0.01}
              min={0}
              precision={2}
              maxIntegerDigits={10}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label="Planned Payable"
            name="planned_payable"
            validateStatus={hasNegativeMargin ? "warning" : undefined}
            help={
              hasNegativeMargin
                ? "Planned Payable exceeds Sales Price"
                : undefined
            }
          >
            <InputNumber
              prefix="$"
              placeholder="0.00"
              step={0.01}
              min={0}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData> label="Margin (Auto)">
            <InputNumber
              prefix="$"
              placeholder="0.00"
              value={margin}
              disabled
              status={hasNegativeMargin ? "warning" : undefined}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label={
              <Tooltip title="Income-to-cost ratio this project is expected to hold. At 3x it should bring in three dollars for every dollar it spends. Used only by the Cash Flow Health indicator - it changes no figure on the Financial Snapshot and does not affect billing.">
                <span>Margin multiplier</span>
              </Tooltip>
            }
            name="margin_multiplier"
          >
            <InputNumber
              suffix="x"
              placeholder="3.00"
              step={0.1}
              min={0}
              precision={2}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item<ProjectFormData>
            label={
              <Tooltip title="How far below the target ratio counts as a warning rather than a problem. At 20%, Cash Flow Health turns orange once income falls below the target and stays orange down to 20% under it. Below that it turns red.">
                <span>Margin warning percentage</span>
              </Tooltip>
            }
            name="margin_warning_percent"
          >
            <InputNumber
              suffix="%"
              placeholder="20"
              step={1}
              min={0}
              max={100}
              precision={2}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
